// src/config/navigation.js
export const navigationLinks = [
    {
        label: "Home",
        to: "/",
        icon: ["fas", "house"],
        isPhone: false,
    },
    {
        label: "Wissenswertes",
        to: "/wissenswertes",
        icon: null,
        isPhone: false,
    },
    {
        label: "Kontakt",
        to: "/kontakt",
        icon: null,
        isPhone: false,
    },
    {
        label: "Praxis",
        to: "/praxis",
        icon: null,
        isPhone: false,
    },
    {
        label: "Leistungen",
        to: "/leistungen",
        icon: null,
        isPhone: false,
    },
    {
        label: "Karriere",
        to: "/karriere",
        icon: null,
        isPhone: false,
    },
    {
        label: "02241 / 8468777",
        to: "tel:02241/8468777",
        icon: ["fas", "phone-volume"],
        isPhone: true,
    },
];
